import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Helmet from 'react-helmet';
import CashbookImportTab from '../../components/forms/Cashbook/CashbookImportTab';

class CashbookImport extends React.Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>Cashbook Import</title>
        </Helmet>
        <Row>
          <Col>
            <Card className="mb-4">
              <Card.Header>Import Consultant Cashbook Balances</Card.Header>
              <Card.Body>
                <p className="hint-text">
                  Upload the Client Account Reconciliation Report to update the cashbook balance shown to each consultant on their dashboard. Nothing is saved
                  until you confirm the preview.
                </p>
                <CashbookImportTab />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default CashbookImport;
